// @flow
// Just a place to pull together polyfills and patches to libs.

import 'app/common/polyfills';
import 'lodash';

import 'es6-collections-iterators';
